import dynamic from 'next/dynamic';
import { useCallback } from 'react';
import { MenuOptionLabel } from '~/constants/srp/MenuOption';
import { useIsInExperiment, useTrackRendered } from '~/hooks/common';
import FilterDrawer from './FilterDrawer';
import useExpand from './useExpand';
import type WithClassName from './WithClassName';
import WithExpandOnOpen from './WithExpandOnOpen';

const Budget = dynamic(
  () => import(/* webpackChunkName: "BudgetFacet" */ './Budget'),
  { ssr: false }
);

const BudgetExperiment = dynamic(
  () =>
    import(
      /* webpackChunkName: "BudgetExperimentFacet" */ './BudgetExperiment'
    ),
  { ssr: false }
);

type OwnProps = WithClassName & WithExpandOnOpen;

export default function PaymentAndPrice({ className, expandOnOpen }: OwnProps) {
  const expandSection = expandOnOpen === MenuOptionLabel.PricePayment;
  const [show, setShow] = useExpand(expandSection);
  const isInExperiment = useIsInExperiment(
    'car-merch-srp-payment-price-filter',
    'treatment'
  );

  useTrackRendered('car-merch-srp-payment-price-filter', show);

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-payment-price"
      facetContent={2}
      facetName="Payment & Price"
      show={show}
      onToggle={useCallback(() => setShow(v => !v), [setShow])}
      expandOnOpen={expandSection}
    >
      <div className="px-24 py-32">
        {isInExperiment ? (
          <BudgetExperiment isShowing={show} />
        ) : (
          <Budget isShowing={show} />
        )}
      </div>
    </FilterDrawer>
  );
}
